import { useEffect, useRef } from 'react'
import { useLatest } from 'react-use'

const MIN_RESUME_DELAY_MS = 1500

interface PausableAutoHideOptions {
  durationMs?: number
  isPaused: boolean
  onExpire: () => void
  resetKey?: unknown
}

export const usePausableAutoHide = ({ durationMs, isPaused, onExpire, resetKey }: PausableAutoHideOptions): void => {
  const onExpireRef = useLatest(onExpire)
  const remaining = useRef<{ key: unknown; ms: number | null }>({ key: resetKey, ms: null })

  useEffect(() => {
    if (durationMs === undefined || isPaused) {
      return undefined
    }
    const left = remaining.current.key !== resetKey || remaining.current.ms === null ? durationMs : remaining.current.ms
    const wait = left < durationMs ? Math.max(left, MIN_RESUME_DELAY_MS) : durationMs
    const startedAt = Date.now()
    const timer = window.setTimeout(() => onExpireRef.current(), wait)
    return () => {
      window.clearTimeout(timer)
      remaining.current = { key: resetKey, ms: Math.max(left - (Date.now() - startedAt), 0) }
    }
  }, [durationMs, isPaused, resetKey, onExpireRef])
}
